import {NgModule} from '@angular/core';
import {EnvironmentRibbonComponent} from './environment-ribbon.component';
import {CommonModule} from '@angular/common';

@NgModule({
    imports: [CommonModule],
    exports: [EnvironmentRibbonComponent],
    declarations: [EnvironmentRibbonComponent]
})

export class EnvironmentRibbonModule {
}
